import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Login from './modules/auth/Login';
import MainLayout from './layouts/MainLayout';
import Dashboard from './modules/dashboard/Dashboard';
import RoomList from './modules/rooms/RoomList';
import RoomForm from './modules/rooms/RoomForm';
import Settings from './modules/settings/Settings';
import OfferList from './modules/offers/OfferList';
import OfferForm from './modules/offers/OfferForm';
import Reports from './modules/reports/Reports';
import PublicOffer from './modules/offers/PublicOffer';
import CalendarView from './modules/calendar/CalendarView';
import RateCalendar from './modules/rates/RateCalendar';
import EventList from './modules/events/EventList';
import EventForm from './modules/events/EventForm';

// Korumalı Rota Bileşeni (Giriş yapılmamışsa Login'e yönlendirir)
const PrivateRoute = ({ children }) => {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            
            {/* Public (Herkese Açık) Rota - Teklif Görüntüleme */}
            <Route path="/offers/view/:id" element={<PublicOffer />} />
            
            <Route element={<PrivateRoute><MainLayout /></PrivateRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/rooms" element={<RoomList />} />
              <Route path="/rooms/new" element={<RoomForm />} />
              <Route path="/rooms/edit/:id" element={<RoomForm />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/offers" element={<OfferList />} />
              <Route path="/offers/new" element={<OfferForm />} />
              <Route path="/offers/edit/:id" element={<OfferForm />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/calendar" element={<CalendarView />} />
              <Route path="/rates" element={<RateCalendar />} />
              {/* Organizasyon teklifleri (nişan, toplantı, mezuniyet …) — ayrı tablo: event_offers */}
              <Route path="/events" element={<EventList />} />
              <Route path="/events/new" element={<EventForm />} />
              <Route path="/events/edit/:id" element={<EventForm />} />
            </Route>
          </Routes>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
